










































import { Component, Mixins } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations } from '@/ts/store/Constants';
import LocalizationMethods from '@/mixins/LocalizationMethods.vue';
import DeviceMethods from '@/mixins/DeviceMethods.vue';
import BaseDropDown from '@/components/DropDowns/BaseDropDown.vue';

@Component({
    computed: {
        ...mapGetters({
            allLanguages: 'Localization/getAllLanguages',
        }),
    },
    components: {
        BaseDropDown,
    },
})
export default class StaffLanguageButton extends Mixins(LocalizationMethods, DeviceMethods) {
    public showLanguageDropDown: boolean = false;

    constructor() {
        super();
    }

    get user() {
        return this.$store.getters['User/getUser'];
    }

    public uploadTranslations() {
        this.showLanguageDropDown = false;
        this.$store.dispatch(Actions.SEND_MISSING_TRANSLATIONS);
    }

    public changeLanguage(lang: string) {
        this.showLanguageDropDown = false;
        this.$store.dispatch(Actions.GLOBAL_CHANGE_LANGUAGE, { vue: this, lang });
        this.$store.commit(Mutations.SET_LOCALIZATION_KEY, lang);
    }
}
